
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Gangren(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Gangren"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    Gangrene is <b>death of body tissue</b> due to a lack of blood flow or
                                    a serious bacterial infection. Gangrene commonly affects the
                                    arms and legs, including the toes and fingers, but it can also
                                    occur in the muscles and in organs inside the body, such as the
                                    gallbladder.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Gangren/1.png")} alt="Gingivitis" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Types of gangrene </b></p>
                                <p><b>Dry gangrene: </b>
                                    This type of gangrene involves dry and shriveled skin that looks brown to
                                    purplish blue or black. Dry gangrene may develop slowly. It occurs most commonly in people
                                    who have diabetes or blood vessel disease, such as atherosclerosis.
                                </p>
                                <p><b>Wet gangrene: </b>
                                    Gangrene is referred to as wet if there's a bacterial infection in the affected
                                    tissue. Swelling, blistering and a wet appearance are common features of wet gangrene.
                                    Wet gangrene may develop after a severe burn, frostbite or injury. It often occurs in people
                                    with diabetes who unknowingly injure a toe or foot. Wet gangrene needs to be treated
                                    immediately because it spreads quickly and can be deadly.
                                </p>
                                <p><b>Gas gangrene: </b>
                                    Gas gangrene typically affects deep muscle tissue. If you have gas gangrene,
                                    the surface of your skin may look normal at first.
                                    <p>As the condition worsens, your skin may become pale and then turn gray or purplish red. The
                                        skin may look bubbly and may make a crackling sound when you press on it because of the
                                        gas within the tissue.</p>
                                    <p>Gas gangrene is most commonly caused by infection with a bacterium called Clostridium
                                        perfringens. Bacteria gather in an injury or surgical wound that has no blood supply. The
                                        bacterial infection produces toxins that release gas and cause tissue death. Like wet
                                        gangrene, gas gangrene is a life-threatening condition.</p>
                                </p>
                                <p><b>Internal gangrene: </b>
                                    Gangrene that affects one or more of your organs, such as your
                                    intestines, gallbladder or appendix, is called internal gangrene. This type of gangrene occurs
                                    when blood flow to an internal organ is blocked — for example, when your intestines bulge
                                    through a weakened area of muscle in your stomach area (hernia) and become twisted.
                                    Left untreated, internal gangrene can be deadly.
                                </p>
                                <p><b>Fournier's gangrene: </b>
                                    Fournier's gangrene involves the genital organs. Men are more often
                                    affected, but women also can develop this type of gangrene. An infection in the genital area
                                    or urinary tract causes this type of gangrene.
                                </p>
                                <p><b>Meleney's gangrene: </b>
                                    This rare type of gangrene — also called progressive bacterial
                                    synergistic gangrene — is usually a complication of surgery. People with Meleney's gangrene
                                    develop painful skin lesions one to two weeks after their operations.
                                </p>
                                <p><b>Symptoms</b></p>
                                <p><b>When gangrene affects your skin, signs and symptoms may include:</b></p>
                                <p>Skin discoloration — ranging from pale to blue, purple, black, bronze or red, depending on the
                                    type of gangrene you have</p>
                                <p>Swelling</p>
                                <p>Blisters</p>
                                <p>Sudden, severe pain followed by a feeling of numbness</p>
                                <p>A foul-smelling discharge leaking from a sore</p>
                                <p>Thin, shiny skin, or skin without hair</p>
                                <p>Skin that feels cool or cold to the touch</p>
                                <p>If you have a type of gangrene that affects tissues beneath the surface of your skin, such as gas gangrene
                                    or internal gangrene, you may also have a low-grade fever and generally feel unwell.</p>
                                <p><b>If the germs that caused the gangrene spread through your body, septic shock can occur. Signs and
                                    symptoms of septic shock include:</b></p>
                                <p>Low blood pressure</p>
                                <p>Fever, although some people may have a body temperature lower than the normal 98.6 F (37 C)</p>
                                <p>Rapid heart rate</p>
                                <p>Lightheadedness</p>
                                <p>Shortness of breath</p>
                                <p>Confusion</p>


                                <a className="links" href="https://en.wikipedia.org/wiki/Gangrene">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Gangren;